module.exports = __webpack_public_path__ + "static/media/arrival-mail.691913ae.png";